import React, { Fragment, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Alert } from '@bechtel/gds';
import { TimesheetDetailContainer } from './styled';
import { useModulePermission, useAppUser, ErrorBoundary, NotFound } from '@bechtel/client-common';
import { TimesheetDetail } from './detail';
import { CrewMembers } from './list';
import { PersonaType } from '@bechtel/types';
import { useTimesheetPermissions } from './hooks';

const Timesheet = () => {
  const { canViewTimeSheetModule } = useModulePermission();
  const { canViewTimesheet } = useTimesheetPermissions();
  const { user } = useAppUser();
  const [forDate, setForDate] = useState<Date>(new Date());
  if (!canViewTimeSheetModule) return <Alert>Sorry, Timesheet module is not activated for this project.</Alert>;
  if (!canViewTimesheet) return <Alert>Sorry, you do not have rights to view timesheet</Alert>;
  const showCrewMembers =
    user?.crewMember?.persona == PersonaType.GENERAL_FOREMAN || user?.crewMember?.persona == PersonaType.SUPERINTENDENT;

  return (
    <Fragment>
      <ErrorBoundary>
        <Routes>
          <Route
            path="/"
            element={
              <TimesheetDetailContainer showCrewMembers={showCrewMembers}>
                <TimesheetDetail showDateHeader={!showCrewMembers} forDate={forDate} setForDate={setForDate} />
              </TimesheetDetailContainer>
            }
          />
          <Route
            path={`:id`}
            element={
              <TimesheetDetailContainer showCrewMembers={showCrewMembers}>
                <TimesheetDetail showDateHeader={!showCrewMembers} forDate={forDate} setForDate={setForDate} />
              </TimesheetDetailContainer>
            }
          />
          <Route
            path="*"
            element={
              <TimesheetDetailContainer showCrewMembers={showCrewMembers}>
                <NotFound />
              </TimesheetDetailContainer>
            }
          />
        </Routes>
      </ErrorBoundary>
      {showCrewMembers && (
        <ErrorBoundary>
          <CrewMembers showDateHeader={showCrewMembers} forDate={forDate} setForDate={setForDate} />
        </ErrorBoundary>
      )}
    </Fragment>
  );
};
export default Timesheet;
